export default __webpack_public_path__ + "static/media/secret_pay_pro.3fee6144.svg";